import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import ListHeader from 'components/inspection/index/list_header';
import ListItem from 'components/inspection/index/list_item';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const Index = ({ inspections, sortBy, onSortChange, loading }) => {
  return (
    <List>
      <ListHeader sortBy={sortBy} onSortChange={onSortChange} />
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {inspections.inspections.map((inspection) => (
          <ListItem key={inspection.id} inspection={inspection} />
        ))}
      </LoaderContainer>
      {!loading && inspections.inspections.length === 0 && (
        <IndexListItem>
          <InfoContainer>
            <FormattedMessage id="empty.inspections.title.short" />
          </InfoContainer>
        </IndexListItem>
      )}
    </List>
  );
};

export default Index;
